<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                :showAddNew="false"
                title="Group Template List"
                :showExtraBtn="false"
            />
        </div>
        <div class="px-2 mb-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onSearch"
                :isHideDate="true"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                    <label for="colFormLabel" class="col-form-label">Search By Template Name</label>
                    <AsyncSelect
                        placeholder="Select template name"
                        v-model="groupTemplate"
                        :additional-query="{ template_type: currentTab }"
                        :api-service="fetchTemplateList"
                        :key="resetIndex"
                    />
                </div>
            </DateQuerySetter>
        </div>
        <div class="col-12 px-2">
            <div class="row">
                <div class="col-6">
                    <TemplateNav
                        @onTabChange="onTabChange"
                        :tabs="templateTabs"
                    />
                </div>
                <div class="col-6 text-right" id="add-new-note"></div>
            </div>
        </div>
        <div class="col-12 px-2 mb-5">
            <ListTable
                :tableItems="tableItems"
                :prescriptionNotes="prescriptionNotes"
                :tabs="templateTabs"
                v-if="loadingStatus === 'loaded'"
                @onSaveTemplate="onSaveTemplate"
            />
        </div>
        <div class="px-2 position-absolute bottom-0">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import ListTable from '@/components/molecule/company/hospital/group-template/GroupTemplateTable.vue';
import TemplateNav from '@/components/molecule/company/hospital/group-template/TemplateNav.vue';
import { inject, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import handleHospital from '@/services/modules/hospital'
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import { useStore } from 'vuex';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import { computed } from 'vue';

const { fetchPrescriptionNotes, fetchGroupTemplateTabs, fetchGroupTemplate, fetchTemplateList } = handleHospital()
const router = useRouter();
const route = useRoute();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false);
const loadingStatus = ref('none');
const prescriptionNotes = ref({});
const groupTemplate = ref(null);
const resetIndex = ref(0);

const params = ref({
    search_txt: '',
    offset: 20
});
const tableItems = ref([]);
const templateTabs = ref([]);
const currentTab = computed(() => route.query.tab || 'rx');

const onTabChange = (tab) => {
    groupTemplate.value = null;
    resetIndex.value++;
    tableItems.value = [];
    getGroupTemplates();
}

const onSaveTemplate = () => {
    onPageChange(1);
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onSearch = () => {
    onPageChange(1);
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getGroupTemplates();
}

function getQuery() {
    let query = `?company_id=${route.params.companyId}`;
    query += `&template_type=${route.query.tab || 'rx'}`;
    if(groupTemplate.value) query += `&template_id=${groupTemplate.value.id}`
    return query;
}

const getGroupTemplateTabs = async () => {
    let query = getQuery();
    await fetchGroupTemplateTabs(query).then(res => {
        if (res.status){
            templateTabs.value = res.data;
        }
    }).catch(err => {
        console.log(err)
    })
}

const getPrescriptionNotes = async () => {
    let query = getQuery();
    
    await fetchPrescriptionNotes(query).then(res => {
        if (res.status){
            prescriptionNotes.value = res.data;
        }
    }).catch(err => {
        console.log(err)
    })
}

const getGroupTemplates = async () => {
    loading.value = true
    
    let query = getQuery();
    await fetchGroupTemplate(query).then(res => {
        loading.value = false
        if (!res.status){
            store.commit("resetPagination")
            tableItems.value = [];
            return;
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

onMounted(() => {
    loadingStatus.value = 'loading'

    Promise.all([
        getPrescriptionNotes(),
        getGroupTemplateTabs(),
        getGroupTemplates()
    ]).then(() => {
        loadingStatus.value = 'loaded';
    })
})
</script>